/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Source context for sensitivity and policy
 * @export
 * @interface SourceContext
 */
export interface SourceContext {
    /**
     * Resource type (e.g. CASE, VULNERABILITY, ALERT)
     * @type {string}
     * @memberof SourceContext
     */
    resourceType?: string;
    /**
     * Resource ID
     * @type {string}
     * @memberof SourceContext
     */
    resourceId?: string;
    /**
     * Tenant ID (optional)
     * @type {string}
     * @memberof SourceContext
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the SourceContext interface.
 */
export function instanceOfSourceContext(value: object): value is SourceContext {
    return true;
}

export function SourceContextFromJSON(json: any): SourceContext {
    return SourceContextFromJSONTyped(json, false);
}

export function SourceContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceContext {
    if (json == null) {
        return json;
    }
    return {
        
        'resourceType': json['resourceType'] == null ? undefined : json['resourceType'],
        'resourceId': json['resourceId'] == null ? undefined : json['resourceId'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
    };
}

export function SourceContextToJSON(json: any): SourceContext {
    return SourceContextToJSONTyped(json, false);
}

export function SourceContextToJSONTyped(value?: SourceContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resourceType': value['resourceType'],
        'resourceId': value['resourceId'],
        'tenantId': value['tenantId'],
    };
}

